export const environment = {
  production: true,
  apiUrl: '/api',
  websocketUrl: '',
  enableDeltaSync: false,
};
